import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import App from './App';
import { isProduction } from './firebase';
import './index.css';

// Set favicon based on environment — non-production uses staging livery
const link = document.createElement('link');
link.rel = 'icon';
link.type = 'image/png';
link.href = isProduction ? '/favicon.png' : '/favicon-staging.png';
document.head.appendChild(link);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
